
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { AliasDeleteUsernameSigning } from "./AliasDeleteUsernameSigning";
import { AliasDeleteUsernameSuccess } from "./AliasDeleteUsernameSuccess";
import { AliasManageUsername } from "./AliasManageUsername";
import { AliasManageUsernameSigning } from "./AliasManageUsernameSigning";
import { AliasManageUsernameSuccess } from "./AliasManageUsernameSuccess";
import { AliasOverview } from "./AliasOverview";
import { AliasStore } from "./AliasStore";
import { history } from "stores/RouterStore";
import { FeatureRoutes } from "components/app/AppRoutes";

// ATTENTION: be aware that this feature is reused to a big portion in sIdentitySettings
// therefor pushing routes is done in a relative way inside the components
// DO NOT CHANGE otherwise sIdentitySettings may break

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class AliasContainer extends React.Component<IProps, {}> {
    store: AliasStore;

    constructor(props: any) {
        super(props);
        this.store = new AliasStore();
    }

    async componentDidMount() {
        try {
            // After reload we restore to root page
            if (history.location.pathname !== FeatureRoutes.USERMANAGEMENT) {
                pushRoute(FeatureRoutes.USERMANAGEMENT);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        return (
            <div>
                <Route exact path={this.props.match.path} render={this.withStore(AliasOverview)} />
                <Route path={this.props.match.path + "/username"} component={this.withStore(AliasManageUsername)} />
                <Route path={this.props.match.path + "/username-signing"} component={this.withStore(AliasManageUsernameSigning)} />
                <Route path={this.props.match.path + "/username-success"} component={this.withStore(AliasManageUsernameSuccess)} />
                <Route path={this.props.match.path + "/delete-username-signing"} component={this.withStore(AliasDeleteUsernameSigning)} />
                <Route path={this.props.match.path + "/delete-username-success"} component={this.withStore(AliasDeleteUsernameSuccess)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/alias/AliasContainer.tsx